// Presentation only: preserve the KB's field identities and requirements.
export function passportLayout<T extends { ids: string[] }>(pages: T[]): T[] {
  const nationality = "pf.identity.nationalities";
  const holder = pages.find((page) => page.ids.includes("pf.identity.given_names"));
  if (!holder) return pages;
  const hasNationality = pages.some((page) => page.ids.includes(nationality));
  return [holder, ...pages.filter((page) => page !== holder)].map((page) => ({
    ...page,
    ids: [...page.ids.filter((id) => id !== nationality), ...(page === holder && hasNationality ? [nationality] : [])],
  }));
}
